import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../../assets/css/agent/user-chat.scss";
import { MdSend } from "react-icons/md";
import { IoIosAttach } from "react-icons/io";
import { AiOutlineReload, AiOutlineDown } from "react-icons/ai";
import { BsEmojiSmileFill } from "react-icons/bs";
import AvatarGirl from "../../assets/images/avatar.png";
import RightBar from "../../components/RightBar";
import useChat from "../../config/useChat";
import { useParams } from "react-router-dom";
import jwt from 'jwt-decode'
import axiosInstance from "../../environment/axiosInstance";

function TicketChat() {
    const { userId } = useParams();
    const [message, setMessage] = useState("");
    const messageRef = useRef("");
    const { messages, sendMessage } = useChat();
    const [ticket, setTicket] = useState(null);
    const [customer, setCustomer] = useState(null);
    const bottomRef = useRef(null);

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer/" + userId)
            .then(response => {
                if (response.data.statusCode == 200) {
                    var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));

                    if (!user_tabs) {
                        var user_tab = {
                            id: userId,
                            name: response.data.Data?.customer_name,
                            email: response.data.Data?.customer_email
                        };

                        localStorage.setItem("user_tabs", JSON.stringify([user_tab]));
                    }
                    else {
                        var tab_exists = user_tabs.filter(tab => tab.id == userId);

                        if (!tab_exists.length) {
                            var user_tab = {
                                id: userId,
                                name: response.data.Data?.customer_name,
                                email: response.data.Data?.customer_email
                            };

                            user_tabs.push(user_tab);

                            localStorage.setItem("user_tabs", JSON.stringify(user_tabs));
                        }
                    }
                }
            });

        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/" + searchParams.get("ticketId"))
            .then(response => {
                if (response.data.statusCode == 200) {
                    setTicket(response.data.Data.ticket);
                    setCustomer(response.data.Data.customer);
                }
            });
    }, []);

    useEffect(() => {
        // 👇️ scroll to bottom every time messages change
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const sendMessageClick = () => {
        if (message) {
            if (messageRef.current.value === "") {
                return false;
            }

            const messageObject = {
                message: message,
                status: "unseen",
                to: customer?._id,
                chat_id: ticket?.chat
            };

            axiosInstance
                .post(process.env.REACT_APP_API_URL + "/support/business_owner/message/send", messageObject)
                .then(response => {
                    if (response.data.statusCode == 200) {
                        sendMessage(messageObject);
                        setMessage("");
                    }
                });
        }
    }

    return (
        <div>
            {/* <UsersTabs /> */}
            <div className="user-chat row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    {/* <FeaturesTab /> */}
                    <div className="chat-content">
                        <div className="top-bar row m-0">
                            <div className="col-8 p-0">
                                <div className="d-flex align-items-center">
                                    <p className="m-0 title">Conversation with {customer?.customer_name}</p>
                                    <div className="ticket-box">
                                        <p className="m-0">#{ticket?.ticket_id}</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="circle active-status"></div>
                                    <p className="m-0 status">{ticket?.ticket_status}</p>
                                </div>
                            </div>
                            <div className="col-4 p-0 d-flex align-items-center">
                                <input type="text" className="form-control search-input" placeholder="Search here..." />
                                <AiOutlineReload
                                    size={20}
                                    color="#999999"
                                    className="ms-auto cursor-pointer"
                                />
                            </div>
                        </div>
                        <div className="chat-section">
                            <div className="top">
                                <div className="text-center">
                                    <p className="m-0 date">10/12/22 14:00</p>
                                </div>
                                <div className="messages">
                                    {
                                        messages.map(message => {
                                            console.log(message);
                                            if (message.to == JSON.parse(localStorage.getItem("user_data"))?.userData?.id) {
                                                return (
                                                    <div className="received-msg">
                                                        <div className="d-flex">
                                                            <div className="avatar">
                                                                <img src={AvatarGirl} width="40px" height="40px" />
                                                            </div>
                                                            <div className="message-box">
                                                                <p className="m-0 message-text">{message.message}</p>
                                                            </div>
                                                        </div>
                                                        {/* <div className="d-flex align-items-center my-1">
                                                            <p className="m-0 loc-time">Lindsay | 3:45pm</p>
                                                        </div> */}
                                                    </div>
                                                )
                                            }
                                            else {
                                                return (
                                                    <div className="ms-auto sent-msg">
                                                        <div className="d-flex justify-content-end">
                                                            <div className="message-box">
                                                                <p className="m-0 message-text">{message.message}</p>
                                                            </div>
                                                            <div className="avatar">
                                                                <img src={AvatarGirl} width="40px" height="40px" />
                                                            </div>
                                                        </div>
                                                        {/* <div className="d-flex align-items-center justify-content-end my-1">
                                                            <p className="m-0 loc-time">{JSON.parse(localStorage.getItem("user_data"))?.name} | 3:45pm</p>
                                                        </div> */}
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                    <div ref={bottomRef} />
                                </div>
                            </div>
                            <div className="reply-section">
                                {/* <div className="d-flex align-items-center">
                                    <p className="m-0 option">Email <AiOutlineDown /></p>
                                    <div className="m-0 d-flex align-items-center email-card">
                                        <img src={AvatarGirl} width="20px" height="20px" />
                                        <p className="m-0 ms-1">kamran@gmail.com</p>
                                    </div>
                                </div> */}
                                <textarea
                                    className="mt-1 form-control reply-input"
                                    placeholder="Type a message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                >{message}</textarea>
                                <div className="mt-2 d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <IoIosAttach
                                            size={26}
                                            color="#878787"
                                        />
                                        <BsEmojiSmileFill
                                            size={22}
                                            color="#878787"
                                        />
                                    </div>
                                    <MdSend
                                        color="#635BFF"
                                        size={30}
                                        onClick={sendMessageClick}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div>
    )
}

export default TicketChat;